import { render } from "./LogoutPopup.vue?vue&type=template&id=0ab48497&scoped=true"
import script from "./LogoutPopup.vue?vue&type=script&lang=js"
export * from "./LogoutPopup.vue?vue&type=script&lang=js"

import "./LogoutPopup.vue?vue&type=style&index=0&id=0ab48497&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab48497"]])

export default __exports__